import { render, staticRenderFns } from "./FormMultas.vue?vue&type=template&id=66d82368&"
import script from "./FormMultas.vue?vue&type=script&lang=js&"
export * from "./FormMultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports